var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DashboardChartBase } from '../widgets/dashboard-chart-base';
var EdByStateSummaryTable = /** @class */ (function (_super) {
    __extends(EdByStateSummaryTable, _super);
    function EdByStateSummaryTable(dataService) {
        var _this = _super.call(this) || this;
        _this.dataService = dataService;
        _this.datas = [];
        _this.tileTitle = 'Endeavour Delivery Summary';
        _this.title = _this.tileTitle;
        return _this;
    }
    EdByStateSummaryTable.prototype.setChartData = function (items) {
        this.datas = items;
        if (items.length > 0) {
            this.fields = Object.keys(items[0]).map(function (k) {
                return {
                    key: k,
                    localizeKey: k.charAt(0).toUpperCase() + k.slice(1),
                    type: Array.isArray(items[0][k]) ? 'Array' : typeof items[0][k]
                };
            });
        }
    };
    EdByStateSummaryTable.prototype.reload = function () {
        var _this = this;
        this.showLoading();
        this.dataService.getConsignmentsForDashboardEdByState().subscribe(function (result) {
            _this.title = _this.tileTitle + ' (' + (result.mainTitle || 'BAU') + ')';
            _this.setChartData(result.consignmentsSummaryDataEdByStates || []);
            _this.hideLoading();
        });
    };
    return EdByStateSummaryTable;
}(DashboardChartBase));
export { EdByStateSummaryTable };
